/* 3 Tree Official — product page: swipe gallery, quantity, variant picker */
(function () {
  'use strict';
  var root = document.querySelector('[data-tt-product]');
  if (!root) return;

  /* ---------- Swipe gallery ---------- */
  var track = root.querySelector('[data-tt-slides]');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.tt-slide')) : [];
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tt-thumb-index]'));

  function setActive(i) {
    thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
    if (thumbs[i]) {
      thumbs[i].setAttribute('aria-current', 'true');
      // keep the active thumb in view within the thumb strip
      if (thumbs[i].scrollIntoView) {
        try { thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      }
    }
    // pause any video that isn't on the now-active slide (no audio bleeding off-screen)
    slides.forEach(function (s, k) {
      if (k === i) return;
      var v = s.querySelector('video');
      if (v && !v.paused) { try { v.pause(); } catch (e) {} }
    });
  }
  function goTo(i) {
    if (!track || !slides[i]) return;
    track.scrollLeft = i * track.clientWidth; // instant & reliable (mandatory snap stalls smooth programmatic scroll)
    setActive(i);
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      goTo(parseInt(t.getAttribute('data-tt-thumb-index'), 10) || 0);
    });
  });
  if (track) {
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      }, 60);
    }, { passive: true });
  }
  function goToMediaId(id) {
    if (id == null) return;
    for (var k = 0; k < slides.length; k++) {
      if (slides[k].getAttribute('data-media-id') === String(id)) { goTo(k); return; }
    }
  }

  /* ---------- Quantity stepper ---------- */
  var qtyInput = root.querySelector('[data-tt-qty-input]');
  root.querySelectorAll('[data-tt-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      var d = parseInt(b.getAttribute('data-tt-qty'), 10);
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
    });
  });

  /* ---------- Scarcity line: reflect whether this exact piece is in the shopper's own cart ---------- */
  (function () {
    var box = root.querySelector('[data-tt-scarcity]');
    if (!box) return;
    var defEl = box.querySelector('[data-tt-scarcity-default]');
    var inCartEl = box.querySelector('[data-tt-scarcity-incart]');
    var vidInput = root.querySelector('[data-tt-variant-id]');
    function apply(inCart) {
      if (defEl) defEl.hidden = inCart;
      if (inCartEl) inCartEl.hidden = !inCart;
    }
    function refresh() {
      var id = vidInput ? String(vidInput.value) : null;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var found = (cart.items || []).some(function (it) {
            return String(it.variant_id) === id || String(it.id) === id;
          });
          apply(!!found);
        })
        .catch(function () { apply(false); });
    }
    refresh();
    root.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('[data-tt-opt]')) refresh();
    });
  })();

  /* ---------- Variants ---------- */
  var dataEl = root.querySelector('[data-tt-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
  if (!variants.length) return;

  var idInput = root.querySelector('[data-tt-variant-id]');
  var priceEl = root.querySelector('[data-tt-price]');
  var compareEl = root.querySelector('[data-tt-compare]');
  var saveEl = root.querySelector('[data-tt-save]');
  var addBtn = root.querySelector('[data-tt-add]');
  var addText = root.querySelector('[data-tt-add-text]');
  var stickyPrice = root.querySelector('[data-tt-sticky-price]');
  var buyBtn = root.querySelector('[data-tt-buynow]');
  var buyErr = root.querySelector('[data-tt-buyerr]');

  function showBuyError(msg) {
    if (!buyErr) return;
    buyErr.textContent = msg;
    buyErr.hidden = false;
  }
  function clearBuyError() {
    if (buyErr) { buyErr.hidden = true; buyErr.textContent = ''; }
  }

  function selectedValues() {
    return Array.prototype.map.call(root.querySelectorAll('[data-tt-opt]'), function (g) {
      var c = g.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function findVariant(sel) {
    return variants.filter(function (v) {
      return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
    })[0];
  }
  function update(scrollImg) {
    var groups = root.querySelectorAll('[data-tt-opt]');
    var v = groups.length === 0 ? variants[0] : findVariant(selectedValues());
    groups.forEach(function (g) {
      var c = g.querySelector('input:checked');
      var lbl = g.querySelector('[data-tt-opt-selected]');
      if (c && lbl) lbl.textContent = c.value;
    });
    if (!v) { if (addBtn) addBtn.disabled = true; if (buyBtn) buyBtn.disabled = true; if (addText) addText.textContent = 'Unavailable'; return; }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.innerHTML = v.price;
    if (stickyPrice) stickyPrice.innerHTML = v.price;
    if (compareEl) { if (v.onSale) { compareEl.hidden = false; compareEl.innerHTML = v.compare; } else compareEl.hidden = true; }
    if (saveEl) { if (v.onSale) { saveEl.hidden = false; saveEl.textContent = 'Save ' + v.save; } else saveEl.hidden = true; }
    if (addBtn) addBtn.disabled = !v.available;
    if (buyBtn) buyBtn.disabled = !v.available;
    if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';
    clearBuyError();
    if (scrollImg) goToMediaId(v.mediaId);
  }
  root.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-tt-opt]')) update(true); });
  update(false);

  /* ---------- Buy it now: add current variant, then straight to checkout ---------- */
  if (buyBtn) {
    buyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (buyBtn.disabled || buyBtn.classList.contains('is-busy')) return;
      var id = idInput ? idInput.value : (variants[0] && variants[0].id);
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (!id) return;
      var original = buyBtn.textContent;
      function reset() { buyBtn.classList.remove('is-busy'); buyBtn.textContent = original; }
      clearBuyError();
      buyBtn.classList.add('is-busy');
      buyBtn.textContent = 'Just a moment…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function (r) {
        // Always read the JSON body so we can surface Shopify's own message on failure
        // (e.g. sold out / not enough stock) instead of bouncing to the raw error page.
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (res) {
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) ||
            'Sorry, this piece can’t be added right now — it may have just sold. Message us on WhatsApp and we’ll help.';
          showBuyError(msg);
          if (res.data && res.data.status === 422 && buyBtn) buyBtn.disabled = true; // truly unavailable
          reset();
          return;
        }
        window.location.href = '/checkout';
      }).catch(function () {
        showBuyError('Something went wrong. Please check your connection and try again, or message us on WhatsApp.');
        reset();
      });
    });
  }
})();
